import './TableClubCard.css'

import PropTypes from 'prop-types'
import React, { useRef } from 'react'
import { FixedSizeList as List } from 'react-window'
import useSyncScroll from 'utils/useSyncScroll'

import TableClubCardHeader from './TableClubCardHeader'
import TableClubCardRow from './TableClubCardRow'

const TableClubCard = ({
  headerClassName,
  itemHeight,
  listHeight,
  maxRevenueClub,
  onFilter,
  onScroll,
  scrollOffset,
  showModal,
  sortBy,
  stores,
  type,
}) => {
  const listRef = useRef()

  useSyncScroll(listRef, scrollOffset)

  return (
    <div className="table-club-card">
      <TableClubCardHeader className={headerClassName} onFilter={onFilter} sortBy={sortBy} type={type} />

      <List
        useIsScrolling
        className="table-club-card-row"
        height={listHeight}
        itemCount={stores.length}
        itemData={{
          maxRevenueClub,
          showModal,
          stores,
          type,
        }}
        itemSize={itemHeight}
        onScroll={onScroll}
        overscanCount={8}
        ref={listRef}
        width="100%"
      >
        {TableClubCardRow}
      </List>
    </div>
  )
}

TableClubCard.propTypes = {
  headerClassName: PropTypes.string,
  itemHeight: PropTypes.number,
  listHeight: PropTypes.number,
  maxRevenueClub: PropTypes.number,
  onFilter: PropTypes.func,
  onScroll: PropTypes.func,
  scrollOffset: PropTypes.number,
  showModal: PropTypes.func,
  sortBy: PropTypes.object,
  stores: PropTypes.array,
  type: PropTypes.string,
}

export default TableClubCard
